import styled, { css } from "styled-components";

export const NewPaywallContainer = styled.div`
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.Primary};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  margin: 24px auto 0px;
  max-width: 940px;
  position: sticky;
  z-index: 1000;
  overflow: hidden;
  bottom: 10px;
  gap: 20px;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.2);

  &:before {
    content:  '';
    display: block;
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.Primary40};
  }

  @media (max-width: 768px) {
    max-width: calc(100% - 20px);
    padding: 24px 20px;
    flex-direction: column;
    text-align: center;
    gap: 16px;
    bottom: 76px;
  }
`;

export const AuthorImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 42px;
    height: 42px;
  }
`;

export const TextWrapper = styled.div`
  flex-grow: 1;
  line-height: normal;
`;

export const Subtitle = styled.p`
  font-size: 24px;
  font-weight: 500;
  text-align: left;
  margin: 0px;
  line-height: normal;
  color: #000;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const GroupName = styled.p`
  font-size: 24px;
  font-weight: 500;
  text-align: left;
  margin: 0;
  line-height: normal;
  color:  ${({ theme }) => theme.colors.Primary};

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const Author = styled.p`
  font-size: 16px;
  margin: 0;
  text-align: left;
  color: #000;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const CTAButton = styled.a`
  background-color: ${({ theme }) => theme.colors.Primary};
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  width: auto;
  transition: background 0.3s ease;

  &:hover {
    background-color:  ${({ theme }) => theme.colors.Primary};
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 13px;
  }
`;
